export const toCamelCase = (s: string) => {
  return s.replace(/([-_][a-z])/ig, (a) => {
    return a.toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
}